import EntryCreate from '@/components/entries/EntryCreate'

const entriesRoutes = [
  { path: '/:type/:id/entry/create', name: 'entry_create', component: EntryCreate }
]

export default entriesRoutes



// WEBPACK FOOTER //
// ./src/router/entries_routes.js